import React, { useEffect, useState } from 'react';
import DataTable, { DataTableColumn } from '../Components/DataTable';
import CreateRoundUtil from '../CreateRound/CreateRoundUtil';
import { FixtureNg, FixtureNgItem } from './FixtureOverviewModels';
import { Box, Button, IconButton, Link } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import FixtureNgDetails from './FixtureNgDetails';
import RoundOverviewUtil from '../RoundOverview/RoundOverviewUtil';

interface FixtureNgTableProps {
    items: FixtureNgItem[];
    onSelect?: (item : FixtureNgItem) => void;
    onDelete? : (item : FixtureNgItem) => void;
}

const FixtureNgTable: React.FC<FixtureNgTableProps> = (props) => {
    const [selectedId, setSelectedId] = useState<number>(0);
    const [columns, setColumns] = useState<DataTableColumn<FixtureNgItem>[]>([]);
 
    useEffect(() => {
      refreshColumns();
    }, []);
    
    const refreshColumns = () => {
      var cols: DataTableColumn<FixtureNgItem>[] = [
        { id: 'id', numeric: false, disablePadding: true, label: "Id", filterEnabled: true },
        { id: 'name', numeric: false, disablePadding: false, label: 'Fixture Ng', filterEnabled: true },
        { id: 'startingAt', numeric: false, disablePadding: false, label: 'Starting at', filterEnabled: true, renderValue: it => CreateRoundUtil.toGameDateString(it.startingAt) },
        { id: 'fixtureId', numeric: false, disablePadding: true, label: "Fixture Id", filterEnabled: true, renderValue: renderFixtureId },
        { id: 'fixtureName', numeric: false, disablePadding: false, label: 'Fixture', filterEnabled: true },
        { id: 'fixtureStartingAt', numeric: false, disablePadding: false, label: 'Fixture Starting at', filterEnabled: true, renderValue: it => CreateRoundUtil.toGameDateString(it.fixtureStartingAt) },
        { id: 'leagueTitle', numeric: false, disablePadding: false, label: 'League', filterEnabled: true },
        { id: 'fixtureStatus', numeric: false, disablePadding: false, label: 'Fixture status', filterEnabled: true },
        { id: 'mappingCount', numeric: false, disablePadding: false, label: '#Mappings' },
      ];
      setColumns(cols);
    }
    const renderAction = (item : FixtureNgItem) : any => {
      return (
        <IconButton aria-label="delete" color="secondary" size="small" onClick={(e: any) => onDelete(item)} disabled={!props.onDelete} >
          <DeleteIcon />
        </IconButton>
      );
    };
    const onSelect = (item : FixtureNgItem) => {
        setSelectedId(item.id);
        if (props.onSelect){
          props.onSelect(item);
          return;
      }
    };
    const onDelete = (item : FixtureNgItem) => {
      if (props.onDelete){
        props.onDelete(item);
      }
    }
    const renderFixtureId = (item : FixtureNgItem) : any => {
      var color : string | undefined = undefined;
      if (item.fixtureId && item.fixtureId > 0) {
        color = RoundOverviewUtil.VALID_COLOR;
      }
      if (color) {
        var content = null;
        if (props.onDelete) {
          content = (<Link component={Button} onClick={e => onDelete(item)}>{item.fixtureId.toString()}</Link>);
        } else {
          content = item.fixtureId.toString();
        }
        return (
          <Box bgcolor={color}>{content}</Box>
        );
      }
      return item.fixtureId.toString();
    };
    const renderDetails = (item : FixtureNgItem) : JSX.Element => {
      return (<FixtureNgDetails fixtureNg={item.item} />);
   };
    return (
      <DataTable columns={columns} items={props.items} getId={it => it.id} orderBy='startingAt' order='asc' resultFilterEnabled={true} size='xsmall' onSelect={onSelect} renderDetails={renderDetails}  />
    );
  };
  
  export default FixtureNgTable;
 